module.exports = __webpack_public_path__ + "static/media/footer-social-twit.0251d8ee.png";